export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5602.a7a4a81d.jpg";